/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ResolvedExcludedProfileMatch } from './resolvedExcludedProfileMatch';

export interface ResolveExcludedPeopleByLinkedinUrlsResponse {
  results: ResolvedExcludedProfileMatch[];
  matched_count: number;
  unmatched_count: number;
}
